define('lq/events/actions/asyncSender',[
    'lq/events/actions/eventAction'
], function(EventAction) {
    'use strict';
        
    function AsyncSender(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(AsyncSender, EventAction);

    AsyncSender.typeName = 'AsyncSender';

    AsyncSender.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };
        
    AsyncSender.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'AsyncSender',
            command: this.eventData.command
        };
    };

    AsyncSender.prototype.execute = function (continuation) {
        continuation();
    };

    return AsyncSender;
});
